// Mock generator: Optimizations v2 — full rule catalog (approx 82 rules)
// Objetivo: visual QA de layouts por rule_key/archetype mientras el BE migra.

const nowIso = () => new Date().toISOString();
const addDaysIso = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString();
};

const toRuleNameFromKey = (key) =>
  String(key || '')
    .replaceAll('_', ' ')
    .replace(/\bmeta\b/i, 'Meta')
    .replace(/\bdiag\b/i, 'Diagnóstico')
    .replace(/\bgoogle\b/i, 'Google')
    .trim() || 'Optimización';

const pick = (arr, idx) => arr[idx % arr.length];

const resolveArchetype = ({ ruleKey, actionType, evaluationWindows, entityType }) => {
  const k = String(ruleKey || '').toLowerCase();
  const at = String(actionType || '').toUpperCase();

  if (k.startsWith('diag_')) return 'G';
  if (k === 'meta_40_enable_advantage_plus_placements_when_manual_cpa_worse_than_historical') return 'F';
  if (at === 'NO_ACTION') return 'C';
  if (evaluationWindows && evaluationWindows.length) return 'B';
  if (at.includes('INCREASE_') || at.includes('DECREASE_') || at.startsWith('ADJUST_') || at.includes('COST_CAP') || at.includes('BID')) return 'D';
  if (at.startsWith('PAUSE_') || at.includes('REPLACE_') || at.includes('ENABLE_')) return 'E';
  if (['SEARCH_TERM', 'KEYWORD', 'PLACEMENT', 'OFFER', 'ASSET'].includes(String(entityType || '').toUpperCase())) return 'F';
  if (k.includes('switch_to_advantage_plus') || k.includes('consolidate') || k.includes('optimize_lp') || k.includes('improve_lp') || k.includes('enable_advantage_plus') || k.includes('expand_audience') || k.includes('create_reels') || k.includes('refresh_creative')) return 'H';
  return 'A';
};

const defaultIntent = (ruleKey) => {
  const k = String(ruleKey || '').toLowerCase();
  if (k.startsWith('diag_')) return 'SCALE';
  if (k.includes('pause') || k.includes('kill_switch') || k.includes('critical')) return 'STOP_LOSSES';
  if (k.includes('decrease') || k.includes('reduce_budget') || k.includes('exclude') || k.includes('negative')) return 'EFFICIENCY';
  if (k.includes('creative') || k.includes('asset') || k.includes('reels')) return 'CREATIVE';
  if (k.includes('fatigue') || k.includes('frequency')) return 'CREATIVE';
  if (k.includes('lp_') || k.includes('landing_page')) return 'IMPROVE_CONVERSION';
  if (k.includes('switch') || k.includes('advantage_plus')) return 'IMPROVE_DELIVERY';
  return 'SCALE';
};

const defaultActionType = (ruleKey) => {
  const k = String(ruleKey || '').toLowerCase();
  if (k.startsWith('diag_rotate')) return 'REFRESH_CREATIVE';
  if (k.startsWith('diag_')) return 'INCREASE_BUDGET';
  if (k.includes('no_action') || k.includes('alert')) return 'NO_ACTION';
  if (k.includes('expand_audience_broad')) return 'EXPAND_AUDIENCE_BROAD';
  if (k.includes('enable_advantage_plus_placements')) return 'ENABLE_ADVANTAGE_PLUS_PLACEMENTS';
  if (k.includes('create_reels_specific_creative') || k.includes('create_reels')) return 'CREATE_REELS_CREATIVE';
  if (k.includes('increase_budget')) return 'INCREASE_BUDGET';
  if (k.includes('decrease_budget') || k.includes('reduce_budget')) return 'DECREASE_BUDGET';
  if (k.includes('pause_keyword')) return 'PAUSE_KEYWORD';
  if (k.includes('pause_adset') || k.includes('pause_entity')) return 'PAUSE_ENTITY';
  if (k.includes('pause_campaign')) return 'PAUSE_ENTITY';
  if (k.includes('pause_ad')) return 'PAUSE_AD';
  if (k.includes('add_negative_keyword')) return 'ADD_NEGATIVE_KEYWORD';
  if (k.includes('add_keyword')) return 'ADD_KEYWORD';
  if (k.includes('exclude_bad_placements') || k.includes('exclude_placement')) return 'EXCLUDE_PLACEMENT';
  if (k.includes('exclude_offer') || k.includes('exclude_product')) return 'EXCLUDE_PRODUCT';
  if (k.includes('switch_to_advantage_plus')) return 'SWITCH_TO_ADVANTAGE_PLUS';
  if (k.includes('consolidate_adsets')) return 'CONSOLIDATE_ADSETS';
  if (k.includes('optimize_lp_speed') || k.includes('landing_page_speed')) return 'OPTIMIZE_LANDING_PAGE_SPEED';
  if (k.includes('improve_lp_relevance') || k.includes('landing_page_relevance')) return 'IMPROVE_LANDING_PAGE_RELEVANCE';
  if (k.includes('adjust_target_roas')) return 'ADJUST_TARGET_ROAS';
  if (k.includes('adjust_target_cpa')) return 'ADJUST_TARGET_CPA';
  if (k.includes('adjust_cost_cap')) return 'ADJUST_COST_CAP';
  if (k.includes('adjust_adset_bid_amount')) return 'ADJUST_ADSET_BID_AMOUNT';
  if (k.includes('increase_bid_costcap')) return 'ADJUST_ADSET_BID_AMOUNT';
  if (k.includes('replace_asset')) return 'REPLACE_ASSET';
  if (k.includes('iterate_winner')) return 'ITERATE_WINNER_AD';
  if (k.includes('split_top_sellers')) return 'SPLIT_TOP_SELLERS';
  if (k.includes('create_campaign_for_good_placements') || k.includes('create_campaign_for_placement')) return 'CREATE_CAMPAIGN';
  return 'NO_ACTION';
};

const actionLabelFromType = (actionType) => {
  const at = String(actionType || '').toUpperCase();
  const map = {
    INCREASE_BUDGET: 'Subir presupuesto',
    DECREASE_BUDGET: 'Bajar presupuesto',
    PAUSE_AD: 'Pausar anuncio',
    PAUSE_ENTITY: 'Pausar entidad',
    PAUSE_KEYWORD: 'Pausar keywords',
    ADD_KEYWORD: 'Agregar keyword',
    ADD_NEGATIVE_KEYWORD: 'Agregar keyword negativa',
    EXCLUDE_PLACEMENT: 'Excluir placement',
    EXCLUDE_PRODUCT: 'Excluir producto',
    SWITCH_TO_ADVANTAGE_PLUS: 'Cambiar a Advantage+',
    CONSOLIDATE_ADSETS: 'Consolidar adsets',
    EXPAND_AUDIENCE_BROAD: 'Expandir audiencia (Broad)',
    ENABLE_ADVANTAGE_PLUS_PLACEMENTS: 'Activar placements Advantage+',
    CREATE_REELS_CREATIVE: 'Crear creativo para Reels',
    OPTIMIZE_LANDING_PAGE_SPEED: 'Mejorar velocidad del sitio',
    IMPROVE_LANDING_PAGE_RELEVANCE: 'Mejorar relevancia del sitio',
    ADJUST_TARGET_ROAS: 'Ajustar target ROAS',
    ADJUST_TARGET_CPA: 'Ajustar target CPA',
    ADJUST_COST_CAP: 'Ajustar cost cap',
    ADJUST_ADSET_BID_AMOUNT: 'Ajustar puja',
    REPLACE_ASSET: 'Reemplazar asset',
    ITERATE_WINNER_AD: 'Iterar anuncio ganador',
    SPLIT_TOP_SELLERS: 'Separar top sellers',
    CREATE_CAMPAIGN: 'Crear campaña',
    NO_ACTION: 'Investigar',
    REFRESH_CREATIVE: 'Renovar creativo',
  };
  return map[at] || 'Aplicar';
};

// Mirrors the BE `applicable` flag for the mock/dev page + tests: action types that
// CANNOT be auto-applied from the app (iterate/fatigue/creative/landing/structural +
// alerts) deep-link to the platform instead; budget/target/pause/keyword actions apply.
const NON_APPLICABLE_ACTIONS = new Set([
  'NO_ACTION', 'ITERATE_WINNER_AD', 'MITIGATE_AUDIENCE_FATIGUE', 'REFRESH_CREATIVE',
  'CREATE_REELS_CREATIVE', 'OPTIMIZE_LANDING_PAGE_SPEED', 'IMPROVE_LANDING_PAGE_RELEVANCE',
  'SWITCH_TO_ADVANTAGE_PLUS', 'CONSOLIDATE_ADSETS', 'EXPAND_AUDIENCE_BROAD',
  'SPLIT_TOP_SELLERS', 'CREATE_CAMPAIGN', 'REPLACE_ASSET',
]);
const isApplicableAction = (actionType) => !NON_APPLICABLE_ACTIONS.has(String(actionType || '').toUpperCase());
const ctaLabelFor = (applicable, platform) =>
  (applicable ? 'Aplicar' : (String(platform || '').toUpperCase() === 'GOOGLE' ? 'Ver en Google' : 'Ver en Meta'));

const primaryEntityFor = ({ platform, entityType, seed }) => {
  const p = platform;
  const type = String(entityType || '').toUpperCase() || 'AD';
  const ext = p === 'META' ? String(120000000000000000 + seed) : String(8000000000 + seed);
  const name = pick(
    [
      'MB | Ventas | ABO | Cashback | Frost y Astro',
      'Ventas | Catálogo | CBO',
      'Búsqueda - Cocina',
      'PMax - Top sellers',
    ],
    seed
  );

  const thumbnailUrl = type === 'AD' ? `https://picsum.photos/seed/${seed}/200/200` : null;
  const permalinkUrl = (() => {
    if (p === 'META') {
      if (type === 'AD') return `https://www.facebook.com/${ext}`;
      return null;
    }
    if (p === 'GOOGLE') {
      if (type === 'CAMPAIGN') return `https://ads.google.com/aw/campaigns?__c=999999&campaignId=${ext}`;
      return null;
    }
    return null;
  })();

  return {
    id: 10000 + seed,
    external_id: ext,
    name: type === 'AD' ? `Anuncio ${seed}` : type === 'AD_GROUP' ? `Adset ${seed}` : type === 'CAMPAIGN' ? name : `${type} ${seed}`,
    platform: p,
    type,
    thumbnail_url: thumbnailUrl,
    permalink_url: permalinkUrl,
  };
};

const makeCriteriaA = ({ primaryKpi }) => {
  if (primaryKpi === 'CPA') {
    return [
      {
        label: 'CPA por debajo del objetivo',
        metric_key: 'cpa',
        comparison: 'lt',
        actual_value: 280,
        threshold_value: 350,
        threshold_label: 'objetivo',
        threshold_source: 'objetivo.target_cpa',
        delta_percent: 20.0,
        format_hint: 'currency_decimal',
        direction_preference: 'lower_is_better',
      },
    ];
  }
  return [
    {
      label: 'ROAS por encima del objetivo',
      metric_key: 'roas',
      comparison: 'gt',
      actual_value: 9.4,
      threshold_value: 7.0,
      threshold_label: 'objetivo',
      threshold_source: 'objetivo.target_roas',
      delta_percent: 34.3,
      format_hint: 'ratio',
      direction_preference: 'higher_is_better',
    },
  ];
};

const makeWindowComparison = ({ metricKey, metricLabel, shortLabel, longLabel, shortKey, longKey, shortValue, longValue, formatHint }) => ({
  metric_key: metricKey,
  metric_label: (metricLabel || metricKey).toUpperCase(),
  windows: [
    { label: shortLabel, key: shortKey, value: shortValue, is_critical: true },
    { label: longLabel, key: longKey, value: longValue, is_critical: false },
  ],
  ratio: longValue === 0 ? 0 : shortValue / longValue,
  ratio_threshold: 0.8,
  ratio_threshold_label: `80% del ${metricKey.toUpperCase()} de 30 días`,
  trend_direction: shortValue < longValue ? 'worsening' : 'improving',
  format_hint: formatHint || 'ratio',
});

const makeSuggestion = (rule, seed) => {
  const ruleKey = rule.key;
  const platform = rule.platform;
  const primaryKpi = rule.primary_kpi;
  const actionType = rule.action_type;
  const archetype = resolveArchetype({
    ruleKey,
    actionType,
    evaluationWindows: rule.evaluation_windows,
    entityType: rule.entity_type,
  });

  const created_at = nowIso();
  const expires_at = addDaysIso(7);

  const criteria = (() => {
    if (archetype === 'G') {
      return [
        {
          label: 'Score ≥ 0.7',
          metric_key: 'scaling_score',
          comparison: 'gte',
          actual_value: 0.82,
          threshold_value: 0.7,
          threshold_label: 'umbral',
          threshold_source: 'diagnostics.scaling',
          delta_percent: 17.1,
          format_hint: 'score_0_1',
          direction_preference: 'higher_is_better',
        },
      ];
    }
    if (archetype === 'B' || archetype === 'C') {
      if (String(ruleKey || '').toLowerCase() === 'meta_34_mitigate_audience_fatigue_high_frequency_ctr_drop') {
        return [
          {
            label: 'Frecuencia alta',
            metric_key: 'frequency',
            comparison: 'gt',
            actual_value: 4.8,
            threshold_value: 3.5,
            threshold_label: 'umbral',
            threshold_source: 'policy.frequency_threshold',
            delta_percent: null,
            format_hint: 'decimal_1',
            direction_preference: 'lower_is_better',
          },
          {
            label: 'CTR cayó vs 14 días',
            metric_key: 'inline_link_click_ctr_ratio_48h_14d',
            comparison: 'lt',
            actual_value: 0.62,
            threshold_value: 0.8,
            threshold_label: '80%',
            threshold_source: '0.8 * 14d',
            delta_percent: -22.5,
            format_hint: 'ratio_pct',
            direction_preference: 'higher_is_better',
          },
        ];
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_n12_alert_adset_cpa_spike_48h') {
        return [
          {
            label: 'CPA 48h vs promedio 14d (al menos +50%)',
            metric_key: 'cpa_ratio_48h_14d',
            comparison: 'gte',
            actual_value: 1.56,
            threshold_value: 1.5,
            threshold_label: '+50%',
            threshold_source: 'policy.cpa_spike_48h_vs_14d_ratio',
            delta_percent: 56.0,
            format_hint: 'ratio',
            direction_preference: 'lower_is_better',
          },
        ];
      }
      const metricKey = primaryKpi === 'CPA' ? 'cpa' : 'roas';
      const ratioKey = `${metricKey}_ratio_7d_30d`;
      return [
        {
          label: `${metricKey.toUpperCase()} de 7 días cayó bajo el 80% de 30 días`,
          metric_key: ratioKey,
          comparison: 'lt',
          actual_value: 0.72,
          threshold_value: 0.8,
          threshold_label: '80%',
          threshold_source: '0.8 * 30d',
          delta_percent: -10.0,
          format_hint: 'ratio_pct',
          direction_preference: 'higher_is_better',
        },
      ];
    }
    if (archetype === 'E') {
      if (String(ruleKey || '').toLowerCase() === 'meta_n1_pause_adset_cpa_critical_streak') {
        return [
          {
            label: 'CPA crítico (48h)',
            metric_key: 'cpa_48h',
            comparison: 'gt',
            actual_value: 1650,
            threshold_value: 650,
            threshold_label: 'objetivo',
            threshold_source: 'objetivo.target_cpa',
            delta_percent: null,
            format_hint: 'currency_decimal',
            direction_preference: 'lower_is_better',
          },
          {
            label: 'Racha crítica (últimos 7 días)',
            metric_key: 'critical_days_last_7d',
            comparison: 'gte',
            actual_value: 5,
            threshold_value: 3,
            threshold_label: 'días',
            threshold_source: 'policy.critical_streak_days',
            delta_percent: null,
            format_hint: 'integer',
            direction_preference: 'lower_is_better',
          },
          {
            label: 'Gasto (7d)',
            metric_key: 'spend_7d',
            comparison: 'gte',
            actual_value: 6200,
            threshold_value: null,
            threshold_label: null,
            threshold_source: null,
            delta_percent: null,
            format_hint: 'currency',
            direction_preference: 'lower_is_better',
          },
        ];
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_n2_pause_campaign_critical_roas') {
        return [
          {
            label: 'ROAS crítico (48h)',
            metric_key: 'roas_48h',
            comparison: 'lt',
            actual_value: 1.1,
            threshold_value: 3.0,
            threshold_label: 'mínimo',
            threshold_source: 'policy.critical_roas_min',
            delta_percent: null,
            format_hint: 'ratio',
            direction_preference: 'higher_is_better',
          },
          {
            label: 'Racha crítica (últimos 7 días)',
            metric_key: 'critical_days_last_7d',
            comparison: 'gte',
            actual_value: 5,
            threshold_value: 3,
            threshold_label: 'días',
            threshold_source: 'policy.critical_streak_days',
            delta_percent: null,
            format_hint: 'integer',
            direction_preference: 'lower_is_better',
          },
          {
            label: 'Gasto (7d)',
            metric_key: 'spend_7d',
            comparison: 'gte',
            actual_value: 7800,
            threshold_value: null,
            threshold_label: null,
            threshold_source: null,
            delta_percent: null,
            format_hint: 'currency',
            direction_preference: 'lower_is_better',
          },
        ];
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_32_pause_ad_spend_stealing_under_roas_with_other_winners') {
        return [
          {
            label: 'ROAS por debajo del objetivo',
            metric_key: 'roas',
            comparison: 'lt',
            actual_value: 1.8,
            threshold_value: 7.0,
            threshold_label: 'objetivo',
            threshold_source: 'objetivo.target_roas',
            delta_percent: null,
            format_hint: 'ratio',
            direction_preference: 'higher_is_better',
          },
          {
            label: 'Concentración de la inversión',
            metric_key: 'adset_spend_share',
            comparison: 'gte',
            actual_value: 0.62,
            threshold_value: 0.5,
            threshold_label: null,
            threshold_source: 'policy.adset_spend_share_threshold',
            delta_percent: null,
            format_hint: 'ratio_pct',
            direction_preference: 'lower_is_better',
            display_mode: 'value_only',
          },
        ];
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_32_pause_ad_spend_stealing_over_cpa_with_other_winners') {
        return [
          {
            label: 'CPA por encima del objetivo',
            metric_key: 'cpa',
            comparison: 'gt',
            actual_value: 1400,
            threshold_value: 420,
            threshold_label: 'objetivo',
            threshold_source: 'objetivo.target_cpa',
            delta_percent: null,
            format_hint: 'currency_decimal',
            direction_preference: 'lower_is_better',
          },
          {
            label: 'Concentración de la inversión',
            metric_key: 'adset_spend_share',
            comparison: 'gte',
            actual_value: 0.62,
            threshold_value: 0.5,
            threshold_label: null,
            threshold_source: 'policy.adset_spend_share_threshold',
            delta_percent: null,
            format_hint: 'ratio_pct',
            direction_preference: 'lower_is_better',
            display_mode: 'value_only',
          },
        ];
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_30_replace_asset_low_3sec_view_rate') {
        return [
          {
            label: 'Tasa de vistas de 3s por debajo del 20%',
            metric_key: 'video_3_sec_rate',
            comparison: 'lt',
            actual_value: 0.12,
            threshold_value: 0.2,
            threshold_label: '20%',
            threshold_source: '0.20',
            delta_percent: null,
            format_hint: 'ratio_pct',
            direction_preference: 'higher_is_better',
          },
          {
            label: 'Gasto',
            metric_key: 'spend',
            comparison: 'gte',
            actual_value: 4200,
            threshold_value: null,
            threshold_label: null,
            threshold_source: null,
            delta_percent: null,
            format_hint: 'currency',
            direction_preference: 'lower_is_better',
          },
        ];
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_31_replace_asset_low_3sec_view_rate_nonvideo') {
        return [
          {
            label: 'Tasa de vistas de 3s por debajo del 20%',
            metric_key: 'video_3_sec_rate',
            comparison: 'lt',
            actual_value: 0.14,
            threshold_value: 0.2,
            threshold_label: '20%',
            threshold_source: '0.20',
            delta_percent: null,
            format_hint: 'ratio_pct',
            direction_preference: 'higher_is_better',
          },
          {
            label: 'Gasto',
            metric_key: 'spend',
            comparison: 'gte',
            actual_value: 4200,
            threshold_value: null,
            threshold_label: null,
            threshold_source: null,
            delta_percent: null,
            format_hint: 'currency',
            direction_preference: 'lower_is_better',
          },
        ];
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_n11_pause_ad_ctr_decline') {
        return [
          {
            label: 'CTR (7d) cayó bajo el 40% del CTR de los 7 días previos',
            metric_key: 'inline_link_click_ctr_ratio_7d_prev_7d',
            comparison: 'lt',
            actual_value: 0.35,
            threshold_value: 0.4,
            threshold_label: '40%',
            threshold_source: 'policy.ctr_decline_vs_prev7d_ratio',
            delta_percent: -35.0,
            format_hint: 'ratio_pct',
            direction_preference: 'higher_is_better',
          },
          {
            label: 'CTR últimos 7 días',
            metric_key: 'inline_link_click_ctr_7d',
            comparison: 'lt',
            actual_value: 0.7,
            threshold_value: 0.8,
            threshold_label: '40% del previo',
            threshold_source: '0.4 * inline_link_click_ctr_prev_7d',
            delta_percent: null,
            format_hint: 'percentage_2d',
            direction_preference: 'higher_is_better',
          },
          {
            label: 'CTR 7 días previos (referencia)',
            metric_key: 'inline_link_click_ctr_prev_7d',
            comparison: 'gte',
            actual_value: 2.0,
            threshold_value: null,
            threshold_label: null,
            threshold_source: null,
            delta_percent: null,
            format_hint: 'percentage_2d',
            direction_preference: 'higher_is_better',
          },
        ];
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_28_pause_ad_when_spend_high_and_no_conversions') {
        return [
          {
            label: 'Gasto',
            metric_key: 'spend',
            comparison: 'gte',
            actual_value: 774.98,
            threshold_value: 24.0,
            threshold_label: '3× presupuesto diario',
            threshold_multiplier: 3,
            threshold_source: '3.0 * adset.daily_budget',
            delta_percent: 3128.25,
            format_hint: 'currency',
            direction_preference: 'lower_is_better',
            display_mode: 'value_only',
          },
          {
            label: 'Conversiones',
            metric_key: 'conversions',
            comparison: 'eq',
            actual_value: 0,
            threshold_value: 0,
            threshold_label: 'esperado >= 1',
            threshold_multiplier: null,
            threshold_source: '0',
            delta_percent: null,
            format_hint: 'integer',
            direction_preference: 'higher_is_better',
            display_mode: 'value_only',
          },
        ];
      }
      return [
        {
          label: 'Cero conversiones',
          metric_key: 'conversions',
          comparison: 'eq',
          actual_value: 0,
          threshold_value: 0,
          threshold_label: '0',
          threshold_source: '0',
          delta_percent: null,
          format_hint: 'integer',
          direction_preference: 'higher_is_better',
        },
        {
          label: 'Gasto alto',
          metric_key: 'spend',
          comparison: 'gte',
          actual_value: 4200,
          threshold_value: null,
          threshold_label: null,
          threshold_source: null,
          delta_percent: null,
          format_hint: 'currency',
          direction_preference: 'lower_is_better',
        },
      ];
    }
    if (archetype === 'F') {
      return [
        {
          label: 'Sub-items que califican',
          metric_key: 'items_under_target_count',
          comparison: 'gte',
          actual_value: 6,
          threshold_value: 1,
          threshold_label: '≥ 1',
          threshold_source: 'items.length',
          delta_percent: null,
          format_hint: 'integer',
          direction_preference: 'lower_is_better',
        },
      ];
    }
    if (archetype === 'H') {
      if (String(ruleKey || '').toLowerCase() === 'meta_35_switch_to_advantage_plus_manual_under_roas_low_conversions') {
        return [
          {
            label: 'ROAS por debajo del objetivo',
            metric_key: 'roas',
            comparison: 'lt',
            actual_value: 4.2,
            threshold_value: 7.0,
            threshold_label: 'objetivo',
            threshold_source: 'objetivo.target_roas',
            delta_percent: -40.0,
            format_hint: 'ratio',
            direction_preference: 'higher_is_better',
          },
          {
            label: 'Pocas conversiones (7d)',
            metric_key: 'conversions_7d',
            comparison: 'lt',
            actual_value: 3,
            threshold_value: 10,
            threshold_label: 'mínimo',
            threshold_source: 'policy.min_conversions_7d',
            delta_percent: null,
            format_hint: 'integer',
            direction_preference: 'higher_is_better',
          },
        ];
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_35_switch_to_advantage_plus_manual_over_cpa_low_conversions') {
        return [
          {
            label: 'CPA por encima del objetivo',
            metric_key: 'cpa',
            comparison: 'gt',
            actual_value: 980,
            threshold_value: 650,
            threshold_label: 'objetivo',
            threshold_source: 'objetivo.target_cpa',
            delta_percent: 50.8,
            format_hint: 'currency_decimal',
            direction_preference: 'lower_is_better',
          },
          {
            label: 'Pocas conversiones (7d)',
            metric_key: 'conversions_7d',
            comparison: 'lt',
            actual_value: 3,
            threshold_value: 10,
            threshold_label: 'mínimo',
            threshold_source: 'policy.min_conversions_7d',
            delta_percent: null,
            format_hint: 'integer',
            direction_preference: 'higher_is_better',
          },
        ];
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_36_consolidate_adsets_high_auction_overlap') {
        return [
          {
            label: 'Overlap de subastas alto',
            metric_key: 'auction_overlap_pct',
            comparison: 'gt',
            actual_value: 0.42,
            threshold_value: 0.25,
            threshold_label: 'umbral',
            threshold_source: 'policy.auction_overlap_threshold',
            delta_percent: null,
            format_hint: 'ratio_pct',
            direction_preference: 'lower_is_better',
          },
          {
            label: 'AdSets compiten por la misma audiencia',
            metric_key: 'overlapping_adsets_count',
            comparison: 'gte',
            actual_value: 3,
            threshold_value: 2,
            threshold_label: 'mínimo',
            threshold_source: 'policy.min_overlapping_adsets',
            delta_percent: null,
            format_hint: 'integer',
            direction_preference: 'lower_is_better',
          },
        ];
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_37_expand_audience_broad_small_audience_cpa_worsening') {
        return [
          {
            label: 'Audiencia pequeña',
            metric_key: 'audience_size',
            comparison: 'lt',
            actual_value: 180000,
            threshold_value: 500000,
            threshold_label: 'mínimo',
            threshold_source: 'policy.min_audience_size',
            delta_percent: null,
            format_hint: 'integer',
            direction_preference: 'higher_is_better',
          },
          {
            label: 'CPA empeoró vs 30 días',
            metric_key: 'cpa_ratio_7d_30d',
            comparison: 'gt',
            actual_value: 1.28,
            threshold_value: 1.15,
            threshold_label: '+15%',
            threshold_source: 'policy.cpa_worsening_ratio',
            delta_percent: 28.0,
            format_hint: 'ratio_pct',
            direction_preference: 'lower_is_better',
          },
          {
            label: 'Pocas conversiones (7d)',
            metric_key: 'conversions_7d',
            comparison: 'lt',
            actual_value: 4,
            threshold_value: 10,
            threshold_label: 'mínimo',
            threshold_source: 'policy.min_conversions_7d',
            delta_percent: null,
            format_hint: 'integer',
            direction_preference: 'higher_is_better',
          },
        ];
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_40_enable_advantage_plus_placements_when_manual_cpa_worse_than_historical') {
        return [
          {
            label: 'CPA peor que el histórico',
            metric_key: 'cpa_ratio_7d_historical',
            comparison: 'gt',
            actual_value: 1.22,
            threshold_value: 1.1,
            threshold_label: '+10%',
            threshold_source: 'policy.cpa_vs_historical_ratio',
            delta_percent: 22.0,
            format_hint: 'ratio_pct',
            direction_preference: 'lower_is_better',
          },
          {
            label: 'Placements manuales limitan el delivery',
            metric_key: 'manual_placements_enabled',
            comparison: 'eq',
            actual_value: 1,
            threshold_value: 1,
            threshold_label: 'sí',
            threshold_source: 'adset.placements_mode',
            delta_percent: null,
            format_hint: 'boolean',
            direction_preference: 'lower_is_better',
          },
          {
            label: 'Pocas conversiones (7d)',
            metric_key: 'conversions_7d',
            comparison: 'lt',
            actual_value: 6,
            threshold_value: 12,
            threshold_label: 'mínimo',
            threshold_source: 'policy.min_conversions_7d',
            delta_percent: null,
            format_hint: 'integer',
            direction_preference: 'higher_is_better',
          },
        ];
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_41_create_reels_specific_creative_high_reels_spend_low_ctr') {
        return [
          {
            label: 'Gasto alto en Reels',
            metric_key: 'reels_spend_share',
            comparison: 'gt',
            actual_value: 0.58,
            threshold_value: 0.35,
            threshold_label: 'umbral',
            threshold_source: 'policy.reels_spend_share_threshold',
            delta_percent: null,
            format_hint: 'ratio_pct',
            direction_preference: 'lower_is_better',
          },
          {
            label: 'CTR en Reels bajo vs promedio',
            metric_key: 'reels_ctr_vs_account_avg',
            comparison: 'lt',
            actual_value: 0.62,
            threshold_value: 0.85,
            threshold_label: '85%',
            threshold_source: 'policy.reels_ctr_ratio_threshold',
            delta_percent: -27.0,
            format_hint: 'ratio_pct',
            direction_preference: 'higher_is_better',
          },
        ];
      }
      return [
        {
          label: 'KPI por debajo del objetivo',
          metric_key: primaryKpi === 'CPA' ? 'cpa' : 'roas',
          comparison: 'lt',
          actual_value: primaryKpi === 'CPA' ? 420 : 4.2,
          threshold_value: primaryKpi === 'CPA' ? 350 : 7.0,
          threshold_label: 'objetivo',
          threshold_source: primaryKpi === 'CPA' ? 'objetivo.target_cpa' : 'objetivo.target_roas',
          delta_percent: -20.0,
          format_hint: primaryKpi === 'CPA' ? 'currency_decimal' : 'ratio',
          direction_preference: primaryKpi === 'CPA' ? 'lower_is_better' : 'higher_is_better',
        },
      ];
    }
    if (archetype === 'D') {
      if (String(ruleKey || '').toLowerCase() === 'meta_29_increase_bid_costcap_low_delivery_good_roas_30d') {
        return [
          {
            label: 'ROAS 30d por encima del objetivo',
            metric_key: 'roas_30d',
            comparison: 'gt',
            actual_value: 9.8,
            threshold_value: 7.0,
            threshold_label: 'objetivo',
            threshold_source: 'objetivo.target_roas',
            delta_percent: 40.0,
            format_hint: 'ratio',
            direction_preference: 'higher_is_better',
          },
          {
            label: 'Pocas impresiones',
            metric_key: 'impressions_3d',
            comparison: 'lt',
            actual_value: 320,
            threshold_value: 500,
            threshold_label: 'mínimo',
            threshold_source: '500',
            delta_percent: null,
            format_hint: 'integer',
            direction_preference: 'higher_is_better',
          },
        ];
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_n8_decrease_budget_adset_cpa_rise_soft') {
        return [
          {
            label: 'CPA subió vs 30 días',
            metric_key: 'cpa_ratio_7d_30d',
            comparison: 'gt',
            actual_value: 1.22,
            threshold_value: 1.1,
            threshold_label: '+10%',
            threshold_source: 'policy.cpa_soft_worsening_ratio',
            delta_percent: 22.0,
            format_hint: 'ratio_pct',
            direction_preference: 'lower_is_better',
          },
          {
            label: 'CPA de 7 días',
            metric_key: 'cpa_7d',
            comparison: 'gt',
            actual_value: 720,
            threshold_value: 590,
            threshold_label: '30d',
            threshold_source: 'metrics.cpa_30d',
            delta_percent: null,
            format_hint: 'currency_decimal',
            direction_preference: 'lower_is_better',
          },
          {
            label: 'Gasto (7d)',
            metric_key: 'spend_7d',
            comparison: 'gte',
            actual_value: 4800,
            threshold_value: null,
            threshold_label: null,
            threshold_source: null,
            delta_percent: null,
            format_hint: 'currency',
            direction_preference: 'lower_is_better',
          },
        ];
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_n9_decrease_budget_campaign_roas_decline_soft') {
        return [
          {
            label: 'ROAS bajó vs 30 días',
            metric_key: 'roas_ratio_7d_30d',
            comparison: 'lt',
            actual_value: 0.74,
            threshold_value: 0.85,
            threshold_label: '85%',
            threshold_source: 'policy.roas_soft_decline_ratio',
            delta_percent: -26.0,
            format_hint: 'ratio_pct',
            direction_preference: 'higher_is_better',
          },
          {
            label: 'ROAS de 7 días',
            metric_key: 'roas_7d',
            comparison: 'lt',
            actual_value: 4.1,
            threshold_value: 5.6,
            threshold_label: '30d',
            threshold_source: 'metrics.roas_30d',
            delta_percent: null,
            format_hint: 'ratio',
            direction_preference: 'higher_is_better',
          },
          {
            label: 'Gasto (7d)',
            metric_key: 'spend_7d',
            comparison: 'gte',
            actual_value: 7200,
            threshold_value: null,
            threshold_label: null,
            threshold_source: null,
            delta_percent: null,
            format_hint: 'currency',
            direction_preference: 'lower_is_better',
          },
        ];
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_n10_decrease_budget_campaign_cpa_rise_soft') {
        return [
          {
            label: 'CPA subió vs 30 días',
            metric_key: 'cpa_ratio_7d_30d',
            comparison: 'gt',
            actual_value: 1.18,
            threshold_value: 1.1,
            threshold_label: '+10%',
            threshold_source: 'policy.cpa_soft_worsening_ratio',
            delta_percent: 18.0,
            format_hint: 'ratio_pct',
            direction_preference: 'lower_is_better',
          },
          {
            label: 'CPA de 7 días',
            metric_key: 'cpa_7d',
            comparison: 'gt',
            actual_value: 840,
            threshold_value: 710,
            threshold_label: '30d',
            threshold_source: 'metrics.cpa_30d',
            delta_percent: null,
            format_hint: 'currency_decimal',
            direction_preference: 'lower_is_better',
          },
          {
            label: 'Gasto (7d)',
            metric_key: 'spend_7d',
            comparison: 'gte',
            actual_value: 9800,
            threshold_value: null,
            threshold_label: null,
            threshold_source: null,
            delta_percent: null,
            format_hint: 'currency',
            direction_preference: 'lower_is_better',
          },
        ];
      }
      return [
        ...makeCriteriaA({ primaryKpi }),
        {
          label: 'Budget util ≥ 90%',
          metric_key: 'budget_utilization',
          comparison: 'gte',
          actual_value: 96,
          threshold_value: 90,
          threshold_label: '90%',
          threshold_source: '0.9',
          delta_percent: 6.7,
          format_hint: 'percentage_0d',
          direction_preference: 'higher_is_better',
        },
      ];
    }
    if (String(ruleKey || '').toLowerCase() === 'meta_33_iterate_winner_roas_and_ctr_above_account_avg') {
      return [
        {
          label: 'ROAS por encima del objetivo',
          metric_key: 'roas',
          comparison: 'gt',
          actual_value: 11.57,
          threshold_value: 8.0,
          threshold_label: 'objetivo',
          threshold_source: 'objetivo.target_roas',
          delta_percent: 44.6,
          format_hint: 'ratio',
          direction_preference: 'higher_is_better',
        },
        {
          label: 'CTR por encima del promedio de cuenta',
          metric_key: 'inline_link_click_ctr',
          comparison: 'gt',
          actual_value: 1.92,
          threshold_value: 1.3,
          threshold_label: 'promedio cuenta',
          threshold_source: 'account.avg_inline_link_click_ctr',
          delta_percent: 47.7,
          format_hint: 'percentage_2d',
          direction_preference: 'higher_is_better',
        },
      ];
    }
    if (String(ruleKey || '').toLowerCase() === 'meta_33_iterate_winner_cpa_and_ctr_above_account_avg') {
      return [
        {
          label: 'CPA por debajo del objetivo',
          metric_key: 'cpa',
          comparison: 'lt',
          actual_value: 214.16,
          threshold_value: 350.0,
          threshold_label: 'objetivo',
          threshold_source: 'objetivo.target_cpa',
          delta_percent: 38.8,
          format_hint: 'currency_decimal',
          direction_preference: 'lower_is_better',
        },
        {
          label: 'CTR por encima del promedio de cuenta',
          metric_key: 'inline_link_click_ctr',
          comparison: 'gt',
          actual_value: 1.92,
          threshold_value: 1.3,
          threshold_label: 'promedio cuenta',
          threshold_source: 'account.avg_inline_link_click_ctr',
          delta_percent: 47.7,
          format_hint: 'percentage_2d',
          direction_preference: 'higher_is_better',
        },
      ];
    }
    return makeCriteriaA({ primaryKpi });
  })();

  const metrics_extended = (() => {
    const currency = platform === 'GOOGLE' ? 'USD' : 'UYU';
    const base = { currency };
    if (archetype === 'G') return { ...base, scaling_score: 0.82, fatigue_score: 0.21, budget_utilization: 92.5, roas_14d: 9.4 };
    if (archetype === 'B' || archetype === 'C') {
      if (String(ruleKey || '').toLowerCase() === 'meta_34_mitigate_audience_fatigue_high_frequency_ctr_drop') {
        return {
          ...base,
          currency,
          frequency: 4.8,
          frequency_48h: 4.8,
          frequency_14d: 3.6,
          inline_link_click_ctr_48h: 0.009,
          inline_link_click_ctr_14d: 0.0145,
          inline_link_click_ctr_ratio_48h_14d: 0.62,
          spend_7d: 4200,
          conversions_7d: 12,
          // extra útil para contexto
          roas_30d: 8.9,
        };
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_n12_alert_adset_cpa_spike_48h') {
        return {
          ...base,
          currency,
          cpa_48h: 780,
          cpa_14d: 500,
          cpa_ratio_48h_14d: 1.56,
          conversions_48h: 6,
          spend_48h: 4680,
          spend_14d: 28000,
          conversions_14d: 56,
          spend_7d: 8200,
          conversions_7d: 16,
        };
      }
      const metricKey = primaryKpi === 'CPA' ? 'cpa' : 'roas';
      return {
        ...base,
        [`${metricKey}_7d`]: primaryKpi === 'CPA' ? 420 : 6.4,
        [`${metricKey}_30d`]: primaryKpi === 'CPA' ? 350 : 8.9,
        [`${metricKey}_ratio_7d_30d`]: 0.72,
        spend_7d: 4200,
        conversions_7d: 12,
        conversions_48h: 2,
        daily_budget: 600,
      };
    }
    if (archetype === 'E') {
      if (String(ruleKey || '').toLowerCase() === 'meta_n1_pause_adset_cpa_critical_streak') {
        return {
          ...base,
          spend: 6200,
          conversions: 6,
          cpa: 1650,
          cpa_48h: 1650,
          cpa_14d: 980,
          cpa_30d: 820,
          spend_7d: 6200,
          conversions_7d: 6,
          critical_days_last_7d: 5,
        };
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_n2_pause_campaign_critical_roas') {
        return {
          ...base,
          spend: 7800,
          conversions: 8,
          roas: 1.1,
          roas_48h: 1.1,
          roas_14d: 3.6,
          roas_30d: 4.2,
          spend_7d: 7800,
          conversions_7d: 8,
          critical_days_last_7d: 5,
        };
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_32_pause_ad_spend_stealing_under_roas_with_other_winners') {
        return {
          ...base,
          spend: 4200,
          roas: 1.8,
          conversions: 3,
          cpa: 1400,
          adset_spend_share: 0.62,
          target_roas: 7.0,
          winners_count: 2,
        };
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_32_pause_ad_spend_stealing_over_cpa_with_other_winners') {
        return {
          ...base,
          spend: 4200,
          roas: 2.4,
          conversions: 3,
          cpa: 1400,
          adset_spend_share: 0.62,
          target_cpa: 420,
          winners_count: 2,
        };
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_30_replace_asset_low_3sec_view_rate') {
        return {
          ...base,
          spend: 4200,
          conversions: 6,
          cpa: 280,
          roas: 7.8,
          video_3_sec_rate: 0.12,
        };
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_31_replace_asset_low_3sec_view_rate_nonvideo') {
        return {
          ...base,
          spend: 4200,
          conversions: 6,
          cpa: 280,
          roas: 7.8,
          video_3_sec_rate: 0.14,
        };
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_n11_pause_ad_ctr_decline') {
        return {
          ...base,
          spend: 2400,
          conversions: 8,
          cpa: 300,
          roas: 4.2,
          inline_link_click_ctr: 0.7,
          inline_link_click_ctr_7d: 0.7,
          inline_link_click_ctr_prev_7d: 2.0,
          inline_link_click_ctr_ratio_7d_prev_7d: 0.35,
          spend_7d: 2400,
          conversions_7d: 8,
        };
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_28_pause_ad_when_spend_high_and_no_conversions') {
        return {
          ...base,
          spend: 774.98,
          conversions: 0,
          cpa: null,
          roas: 0,
          daily_budget_adset: 8.0,
        };
      }
      return {
        ...base,
        spend: 4200,
        conversions: 0,
        cpa: null,
        roas: 0.0,
      };
    }
    if (archetype === 'F') return { ...base, items_under_target_count: 6, items_under_target_cost: 1200.5, campaign_spend: 8500, campaign_roas: 4.9 };
    // Para compat con UI actual: siempre poblamos las 4 métricas canónicas cuando tiene sentido.
    if (String(ruleKey || '').toLowerCase() === 'meta_33_iterate_winner_roas_and_ctr_above_account_avg') {
      return {
        ...base,
        roas: 11.57,
        inline_link_click_ctr: 1.92,
        spend: 1927.47,
        conversions: 9,
        cpa: 214.16,
      };
    }
    if (String(ruleKey || '').toLowerCase() === 'meta_33_iterate_winner_cpa_and_ctr_above_account_avg') {
      return {
        ...base,
        roas: 8.4,
        inline_link_click_ctr: 1.92,
        spend: 1927.47,
        conversions: 9,
        cpa: 214.16,
      };
    }
    if (archetype === 'H') {
      if (String(ruleKey || '').toLowerCase() === 'meta_35_switch_to_advantage_plus_manual_under_roas_low_conversions') {
        return {
          ...base,
          currency,
          roas_7d: 4.2,
          roas_30d: 6.1,
          conversions_7d: 3,
          spend_7d: 3100,
          cpa_7d: 980,
        };
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_35_switch_to_advantage_plus_manual_over_cpa_low_conversions') {
        return {
          ...base,
          currency,
          cpa_7d: 980,
          cpa_30d: 720,
          conversions_7d: 3,
          spend_7d: 3100,
          roas_30d: 6.1,
        };
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_36_consolidate_adsets_high_auction_overlap') {
        return {
          ...base,
          currency,
          auction_overlap_pct: 0.42,
          overlapping_adsets_count: 3,
          spend_7d: 5600,
          conversions_7d: 11,
          roas_7d: 4.8,
          roas_30d: 6.2,
          cpa_7d: 740,
        };
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_37_expand_audience_broad_small_audience_cpa_worsening') {
        return {
          ...base,
          currency,
          audience_size: 180000,
          cpa_7d: 980,
          cpa_30d: 765,
          cpa_ratio_7d_30d: 1.28,
          spend_7d: 4200,
          conversions_7d: 4,
          roas_30d: 4.9,
        };
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_40_enable_advantage_plus_placements_when_manual_cpa_worse_than_historical') {
        return {
          ...base,
          currency,
          cpa_7d: 980,
          cpa_historical: 800,
          cpa_ratio_7d_historical: 1.22,
          conversions_7d: 6,
          spend_7d: 5200,
          manual_placements_enabled: 1,
        };
      }
      if (String(ruleKey || '').toLowerCase() === 'meta_41_create_reels_specific_creative_high_reels_spend_low_ctr') {
        return {
          ...base,
          currency,
          reels_spend_share: 0.58,
          reels_ctr: 0.006,
          ctr_total_avg: 0.012,
          reels_ctr_vs_account_avg: 0.62,
          spend_7d: 6400,
          conversions_7d: 9,
          cpa_7d: 710,
        };
      }
      return { ...base, currency, roas_7d: 4.2, roas_30d: 6.1, conversions_7d: 5, spend_7d: 4200 };
    }
    if (String(ruleKey || '').toLowerCase() === 'meta_29_increase_bid_costcap_low_delivery_good_roas_30d') {
      return {
        ...base,
        roas: 9.4,
        roas_30d: 9.8,
        impressions_3d: 320,
        spend: 4200,
        conversions: 30,
        cpa: 280,
        cost_cap_current: 280,
        cost_cap_suggested: 350,
      };
    }
    if (String(ruleKey || '').toLowerCase() === 'meta_n8_decrease_budget_adset_cpa_rise_soft') {
      return {
        ...base,
        currency,
        spend: 4800,
        conversions: 11,
        cpa: 720,
        cpa_7d: 720,
        cpa_30d: 590,
        cpa_ratio_7d_30d: 1.22,
        spend_7d: 4800,
        conversions_7d: 11,
        daily_budget: 600,
        budget_utilization: 78,
      };
    }
    if (String(ruleKey || '').toLowerCase() === 'meta_n9_decrease_budget_campaign_roas_decline_soft') {
      return {
        ...base,
        currency,
        spend: 7200,
        conversions: 14,
        roas: 4.1,
        roas_7d: 4.1,
        roas_30d: 5.6,
        roas_ratio_7d_30d: 0.74,
        spend_7d: 7200,
        conversions_7d: 14,
        daily_budget: 1200,
        budget_utilization: 81,
      };
    }
    if (String(ruleKey || '').toLowerCase() === 'meta_n10_decrease_budget_campaign_cpa_rise_soft') {
      return {
        ...base,
        currency,
        spend: 9800,
        conversions: 18,
        cpa: 840,
        cpa_7d: 840,
        cpa_30d: 710,
        cpa_ratio_7d_30d: 1.18,
        spend_7d: 9800,
        conversions_7d: 18,
        daily_budget: 1500,
        budget_utilization: 83,
      };
    }
    return { ...base, roas: 9.4, cpa: 280, spend: 4200, conversions: 30, inline_link_click_ctr: 1.92 };
  })();

  const window_comparison =
    archetype === 'B' || archetype === 'C'
      ? (String(ruleKey || '').toLowerCase() === 'meta_34_mitigate_audience_fatigue_high_frequency_ctr_drop'
        ? makeWindowComparison({
            metricKey: 'inline_link_click_ctr',
            metricLabel: 'CTR',
            shortLabel: 'Últimas 48 horas',
            longLabel: 'Últimos 14 días',
            shortKey: 'inline_link_click_ctr_48h',
            longKey: 'inline_link_click_ctr_14d',
            shortValue: 0.009,
            longValue: 0.0145,
            formatHint: 'ratio',
          })
        : String(ruleKey || '').toLowerCase() === 'meta_n12_alert_adset_cpa_spike_48h'
          ? makeWindowComparison({
              metricKey: 'cpa',
              metricLabel: 'CPA',
              shortLabel: 'Últimas 48 horas',
              longLabel: 'Promedio últimos 14 días',
              shortKey: 'cpa_48h',
              longKey: 'cpa_14d',
              shortValue: 780,
              longValue: 500,
              formatHint: 'currency_decimal',
            })
        : makeWindowComparison({
            metricKey: primaryKpi === 'CPA' ? 'cpa' : 'roas',
            shortLabel: archetype === 'C' ? 'Últimas 48 horas' : 'Últimos 7 días',
            longLabel: archetype === 'C' ? 'Últimos 14 días' : 'Últimos 30 días',
            shortKey: primaryKpi === 'CPA' ? (archetype === 'C' ? 'cpa_48h' : 'cpa_7d') : archetype === 'C' ? 'roas_48h' : 'roas_7d',
            longKey: primaryKpi === 'CPA' ? (archetype === 'C' ? 'cpa_14d' : 'cpa_30d') : archetype === 'C' ? 'roas_14d' : 'roas_30d',
            shortValue: primaryKpi === 'CPA' ? (archetype === 'C' ? 520 : 420) : archetype === 'C' ? 3.2 : 6.4,
            longValue: primaryKpi === 'CPA' ? (archetype === 'C' ? 350 : 350) : archetype === 'C' ? 6.4 : 8.9,
          }))
      : null;

  if (window_comparison && archetype === 'C') {
    window_comparison.alert_severity = 'high';
    window_comparison.alert_window_label = 'Últimas 48 horas';
    window_comparison.baseline_window_label = 'Últimos 14 días';
  }

  if (String(ruleKey || '').toLowerCase() === 'meta_n12_alert_adset_cpa_spike_48h' && window_comparison) {
    window_comparison.ratio_threshold = 1.5;
    window_comparison.ratio_threshold_label = '+50% vs promedio de 14 días';
    window_comparison.trend_direction = 'worsening';
  }

  // Extra de mock para arquetipo B/C: alineamos métricas con las ventanas del comparador cuando aplica.
  if ((archetype === 'B' || archetype === 'C') && metrics_extended && typeof metrics_extended === 'object') {
    const wc = window_comparison;
    if (wc?.metric_key && wc?.windows?.length >= 2) {
      const mk = String(wc.metric_key).toLowerCase();
      const aKey = String(wc.windows[0]?.key || '');
      const bKey = String(wc.windows[1]?.key || '');
      // No pisamos si ya existe.
      if (aKey && metrics_extended[aKey] == null) metrics_extended[aKey] = wc.windows[0].value;
      if (bKey && metrics_extended[bKey] == null) metrics_extended[bKey] = wc.windows[1].value;
      if (mk === 'roas') {
        if (metrics_extended.roas_7d == null) metrics_extended.roas_7d = wc.windows[0].value;
        if (metrics_extended.roas_30d == null) metrics_extended.roas_30d = wc.windows[1].value;
      }
      if (mk === 'cpa') {
        if (aKey === 'cpa_48h' && bKey === 'cpa_14d') {
          if (metrics_extended.cpa_48h == null) metrics_extended.cpa_48h = wc.windows[0].value;
          if (metrics_extended.cpa_14d == null) metrics_extended.cpa_14d = wc.windows[1].value;
        } else {
          if (metrics_extended.cpa_7d == null) metrics_extended.cpa_7d = wc.windows[0].value;
          if (metrics_extended.cpa_30d == null) metrics_extended.cpa_30d = wc.windows[1].value;
        }
      }
    }
  }

  const value_change_display =
    archetype === 'D'
      ? (String(ruleKey || '').toLowerCase() === 'meta_29_increase_bid_costcap_low_delivery_good_roas_30d'
        ? {
            field_label: 'Cost Cap',
            value_before: 280,
            value_after: 350,
            delta_absolute: 70,
            delta_percent: 25.0,
            currency: metrics_extended.currency || 'USD',
            direction: 'increase',
            format_hint: 'currency_decimal',
          }
        : {
            field_label: actionType === 'ADJUST_TARGET_ROAS' ? 'Target ROAS' : 'Presupuesto diario',
            value_before: actionType === 'ADJUST_TARGET_ROAS' ? 7.0 : 600,
            value_after: actionType === 'ADJUST_TARGET_ROAS' ? 8.5 : 510,
            delta_absolute: actionType === 'ADJUST_TARGET_ROAS' ? 1.5 : -90,
            delta_percent: actionType === 'ADJUST_TARGET_ROAS' ? 21.4 : -15.0,
            currency: actionType === 'ADJUST_TARGET_ROAS' ? null : metrics_extended.currency || 'USD',
            direction: actionType === 'INCREASE_BUDGET' ? 'increase' : 'decrease',
            format_hint: actionType === 'ADJUST_TARGET_ROAS' ? 'ratio' : 'currency_decimal',
          })
      : null;

  // Value-modifying B/C cards keep value_change_display null (D-only per contract) but
  // carry the amount in the compat fields value_before/value_after/value_unit, so the
  // FE can synthesize the before→after (e.g. a B "Reducir presupuesto").
  const bcValueChange =
    (archetype === 'B' || archetype === 'C')
    && /BUDGET|TARGET_ROAS|TARGET_CPA|COST_CAP|BID/.test(String(actionType || '').toUpperCase())
      ? (() => {
          const isRoas = /ROAS/.test(String(actionType).toUpperCase());
          return {
            before: isRoas ? 7.0 : 600,
            after: isRoas ? 8.5 : 510, // -15% budget for the decrease cases
            unit: isRoas ? 'ratio' : (metrics_extended.currency || 'UYU'),
          };
        })()
      : null;

  const diagnostic_score =
    archetype === 'G'
      ? {
          score_key: 'scaling',
          score_label: 'Capacidad de escalar',
          score_value: 0.82,
          score_threshold: 0.7,
          score_zones: [
            { from: 0.0, to: 0.5, label: 'Bajo', color: 'neutral' },
            { from: 0.5, to: 0.7, label: 'Medio', color: 'warning' },
            { from: 0.7, to: 1.0, label: 'Alto', color: 'success' },
          ],
          contributing_signals: [
            { label: 'ROAS sobre objetivo por 14d', weight: 0.4 },
            { label: 'Budget utilization > 90%', weight: 0.3 },
            { label: 'Sin señales de fatiga', weight: 0.3 },
          ],
        }
      : null;

  const structural_change =
    archetype === 'H'
      ? (String(ruleKey || '').toLowerCase() === 'meta_36_consolidate_adsets_high_auction_overlap'
        ? {
            change_type: 'CONSOLIDATE_ADSETS',
            change_label: actionLabelFromType(actionType),
            current_state: 'Múltiples AdSets compitiendo',
            proposed_state: '1 AdSet consolidado',
            rationale_short: 'Reducir competencia interna y mejorar el aprendizaje del algoritmo',
            expected_outcomes: ['Menos superposición', 'Mejor delivery', 'Más estabilidad'],
            requires_review: true,
            estimated_setup_minutes: 20,
          }
        : String(ruleKey || '').toLowerCase() === 'meta_37_expand_audience_broad_small_audience_cpa_worsening'
          ? {
              change_type: 'EXPAND_AUDIENCE_BROAD',
              change_label: actionLabelFromType(actionType),
              current_state: 'Segmentación acotada',
              proposed_state: 'Broad (audiencia amplia)',
              rationale_short: 'Con una audiencia pequeña, el delivery se encarece y el CPA tiende a subir.',
              expected_outcomes: ['Más alcance', 'Mejor delivery', 'Menor CPA con más señales'],
              requires_review: true,
              estimated_setup_minutes: 10,
            }
          : String(ruleKey || '').toLowerCase() === 'meta_40_enable_advantage_plus_placements_when_manual_cpa_worse_than_historical'
            ? {
                change_type: 'ENABLE_ADVANTAGE_PLUS_PLACEMENTS',
                change_label: actionLabelFromType(actionType),
                current_state: 'Placements manuales',
                proposed_state: 'Advantage+ placements',
                rationale_short: 'Con placements manuales, el delivery se restringe y el CPA suele subir.',
                expected_outcomes: ['Más inventario', 'Mejor delivery', 'Mejor CPA'],
                requires_review: true,
                estimated_setup_minutes: 5,
              }
          : String(ruleKey || '').toLowerCase() === 'meta_41_create_reels_specific_creative_high_reels_spend_low_ctr'
            ? {
                change_type: 'CREATE_REELS_CREATIVE',
                change_label: actionLabelFromType(actionType),
                current_state: 'Creativo genérico',
                proposed_state: 'Creativo para Reels',
                rationale_short: 'Reels tiene un consumo alto de presupuesto, pero el CTR está por debajo del promedio.',
                expected_outcomes: ['Mejor CTR en Reels', 'Mejor eficiencia', 'Más conversiones'],
                requires_review: true,
                estimated_setup_minutes: 30,
              }
        : {
            change_type: 'SWITCH_BIDDING_STRATEGY',
            change_label: actionLabelFromType(actionType),
            current_state: 'MANUAL',
            proposed_state: 'ADVANTAGE_PLUS',
            rationale_short: 'Mejorar delivery con optimización automática',
            expected_outcomes: ['Mayor exploración', 'Mejor bidding', 'Mejor eficiencia'],
            requires_review: true,
            estimated_setup_minutes: 15,
          })
      : null;

  const isMeta40Placements =
    String(ruleKey || '').toLowerCase() === 'meta_40_enable_advantage_plus_placements_when_manual_cpa_worse_than_historical';

  const sub_items =
    archetype === 'F'
      ? (isMeta40Placements
        ? [
            {
              id: 'placement_feed',
              type: 'placement',
              name: 'Feed',
              metrics: {
                spend: 12480,
                cpa: 980,
                historical_cpa: 720,
                spend_share: 0.62,
                ctr: 0.0095,
                expected_share: 0.45,
              },
              criteria_evaluation: [],
              selected_by_default: true,
              action_payload: { op: 'enable_advantage_plus_placements', placement: 'Feed' },
            },
            {
              id: 'placement_stories',
              type: 'placement',
              name: 'Stories',
              metrics: {
                spend: 3620,
                cpa: 910,
                historical_cpa: 760,
                spend_share: 0.18,
                ctr: 0.0078,
                expected_share: 0.25,
              },
              criteria_evaluation: [],
              selected_by_default: true,
              action_payload: { op: 'enable_advantage_plus_placements', placement: 'Stories' },
            },
            {
              id: 'placement_reels',
              type: 'placement',
              name: 'Reels',
              metrics: {
                spend: 1010,
                cpa: 1320,
                historical_cpa: 880,
                spend_share: 0.05,
                ctr: 0.0061,
                expected_share: 0.20,
              },
              criteria_evaluation: [],
              selected_by_default: true,
              action_payload: { op: 'enable_advantage_plus_placements', placement: 'Reels' },
            },
            {
              id: 'placement_audience_network',
              type: 'placement',
              name: 'Audience Network',
              metrics: {
                spend: 0,
                cpa: null,
                historical_cpa: null,
                spend_share: 0.0,
                ctr: null,
                expected_share: null,
              },
              criteria_evaluation: [],
              selected_by_default: false,
              action_payload: { op: 'enable_advantage_plus_placements', placement: 'Audience Network' },
            },
          ]
        : Array.from({ length: 6 }).map((_, i) => ({
          id: `sub_${seed}_${i}`,
          type: pick(['SEARCH_TERM', 'KEYWORD', 'PLACEMENT', 'OFFER', 'ASSET'], seed + i),
          name: `${pick(['tabla picada madera', 'cuchillo chef', 'bambu chico', 'reels placement', 'oferta 2x1'], seed + i)} (${i + 1})`,
          metrics: { roas: 0.6 + i * 0.2, cpa: 1200 - i * 120, cost: 180 + i * 35, conversions: i % 2, currency: metrics_extended.currency || 'USD' },
          criteria_evaluation: [
            { metric_key: primaryKpi === 'CPA' ? 'cpa' : 'roas', actual_value: 0.6 + i * 0.2, threshold_value: 7.0, passes_criterion: false, delta_percent: -80 },
          ],
          selected_by_default: i < 4,
          action_payload: { op: String(actionType || '').toLowerCase(), id: `sub_${seed}_${i}` },
        })))
      : null;

  const sub_items_summary =
    archetype === 'F'
      ? (isMeta40Placements
        ? {
          total_count: 4,
          selected_count: 3,
          total_cost: 17110,
          total_conversions: 0,
          currency: 'UYU',
        }
        : {
          total_count: 6,
          selected_count: 4,
          total_cost: 1200.5,
          total_conversions: 3,
          currency: metrics_extended.currency || 'USD',
        })
      : null;

  const primary_entity = primaryEntityFor({ platform, entityType: rule.entity_type, seed });

  const scope_entity = (() => {
    const parentType = primary_entity.type === 'AD' ? 'AD_GROUP' : 'CAMPAIGN';
    return {
      id: primary_entity.id + 1,
      external_id: String(Number(primary_entity.external_id) + 1),
      name: parentType === 'AD_GROUP' ? `Adset ${seed}` : `Campaña ${seed}`,
      platform,
      type: parentType,
      thumbnail_url: null,
      permalink_url: null,
    };
  })();

  const campaign = {
    external_id: scope_entity.type === 'CAMPAIGN' ? scope_entity.external_id : String(Number(scope_entity.external_id) + 100),
    name: `Campaña ${seed}`,
  };

  const items =
    archetype === 'F'
      ? []
      : [
          {
            id: 90000 + seed,
            item_type: primary_entity.type,
            item_text: primary_entity.name,
            target_entity: primary_entity,
            // La UI actual espera estas 4 keys canónicas bastante seguido. Para diseño,
            // es mejor inventar valores coherentes aunque el KPI primario sea otro.
            metrics: archetype === 'E'
              ? (String(ruleKey || '').toLowerCase() === 'meta_32_pause_ad_spend_stealing_under_roas_with_other_winners'
                ? { spend: 4200, roas: 1.8, conversions: 3, cpa: 1400 }
                : String(ruleKey || '').toLowerCase() === 'meta_32_pause_ad_spend_stealing_over_cpa_with_other_winners'
                  ? { spend: 4200, roas: 2.4, conversions: 3, cpa: 1400 }
                  : { spend: 4200, roas: 0.0, conversions: 0, cpa: null })
              : {
                  spend: 1200 + seed * 3,
                  roas: 9.4,
                  conversions: 12,
                  cpa: 280,
                },
            metrics_extended: metrics_extended,
            // §6.14: per-item ordered key list.
            metric_keys_to_show: Object.keys(metrics_extended || {}).filter((k) => k !== 'currency').slice(0, 8),
            criteria_evaluation: archetype === 'G' ? null : criteria.map((c) => ({
              metric_key: c.metric_key,
              actual_value: c.actual_value,
              threshold_value: c.threshold_value,
              passes_criterion: true,
              delta_percent: c.delta_percent ?? null,
            })),
            value_change: archetype === 'D' ? value_change_display : null,
            action: { operation: String(actionType || '').toLowerCase(), params: {}, raw_action: null, item_id: primary_entity.external_id, parent_type: scope_entity.type, parent_id: scope_entity.external_id },
            created_at,
            applied_at: null,
            is_liked: null,
          },
        ];

  const uiMetricsCompat = (() => {
    const currency = metrics_extended.currency || 'USD';
    const target_roas = 7.0;
    const target_cpa = 350.0;
    const budget_utilization_pct = 92;
    const daily_budget = 600;

    // Reusar métricas que ya tenemos
    const current_roas = metrics_extended.roas ?? 9.4;
    const current_cpa = metrics_extended.cpa ?? 280;
    const spend = metrics_extended.spend ?? 1200;
    const conversions = metrics_extended.conversions ?? 12;

    // Para arquetipo C (alerta) y NO_ACTION, mostrar ventanas si existen
    const wc = window_comparison;
    const shortKey = wc?.windows?.[0]?.key;
    const longKey = wc?.windows?.[1]?.key;

    return {
      currency,
      current_roas,
      target_roas,
      current_cpa,
      target_cpa,
      budget_utilization_pct,
      daily_budget,
      spend,
      conversions,
      ...(shortKey ? { [shortKey]: wc.windows[0].value } : {}),
      ...(longKey ? { [longKey]: wc.windows[1].value } : {}),
    };
  })();

  return {
    id: 2000 + seed,
    status: 'NEW',
    is_liked: null,
    user_feedback: null,
    creation_origin: 'BATCH',
    created_at,
    updated_at: created_at,
    expires_at,
    applied_at: null,
    brand_id: 475,
    objetivo_id: 2963,
    platform,
    primary_kpi: primaryKpi,

    rule: {
      id: rule.id,
      key: rule.key,
      name: rule.name,
      description: rule.description,
      ui_metadata: rule.ui_metadata,
    },
    rule_id: null,
    diagnostic_rule_id: null,
    optimization_policy_id: rule.id,

    intent: rule.intent,
    action_type: actionType,
    action_label:
      String(ruleKey || '').toLowerCase() === 'meta_n11_pause_ad_ctr_decline'
        ? 'Revisar anuncio'
        : actionLabelFromType(actionType),
    user_text:
      String(ruleKey || '').toLowerCase() === 'meta_29_increase_bid_costcap_low_delivery_good_roas_30d'
        ? (
          '<p>Encontramos Ad Sets que casi no están entregando impresiones en los últimos días.</p>' +
          '<p>Esto sucede porque el Cost Cap configurado es demasiado bajo para competir en las subastas actuales.</p>' +
          '<p>Dado que el conjunto de anuncios mostró <b>ROAS 30d superior al objetivo</b>, el problema no es de rentabilidad sino de puja.</p>' +
          '<p>En resumen: el Ad Set es eficiente, pero está frenado por una puja restrictiva. Incrementar el Cost Cap permitiría volver a competir y capturar volumen.</p>'
        )
        : String(ruleKey || '').toLowerCase() === 'meta_n11_pause_ad_ctr_decline'
          ? (
            '<p>Encontramos anuncios cuyo <b>CTR de los últimos 7 días cayó por debajo del 40% del CTR de los 7 días previos</b>.</p>' +
            '<p>Una caída de esa magnitud indica fatiga de audiencia o pérdida de relevancia del creativo.</p>' +
            '<p>Mantener el anuncio activo desvía presupuesto que rendiría más en variantes con mejor desempeño dentro del mismo Ad Set.</p>' +
            '<p>En resumen: el creativo dejó de funcionar. Pausarlo protege el presupuesto y libera espacio para iterar nuevas variantes.</p>'
          )
        : String(ruleKey || '').toLowerCase() === 'meta_n12_alert_adset_cpa_spike_48h'
          ? (
            '<p>El CPA de este conjunto de anuncios en las últimas 48 horas está al menos un <b>50% por encima</b> de su promedio de los últimos 14 días, con volumen de conversiones suficiente para que la señal no sea ruido.</p>' +
            '<p>Un desvío de corto plazo de esta magnitud suele reflejar un cambio puntual: una rotación reciente de creatividad, un ajuste de puja, una saturación de audiencia o competencia más agresiva en la subasta. Si no se corrige rápido, arrastra el rendimiento del periodo completo.</p>' +
            '<p>Recomendamos revisar las entregas de las últimas 48h, identificar la causa probable del desvío y, si persiste, considerar pausar el conjunto o ajustar la puja antes de gastar más al CPA actual.</p>' +
            '<p>En resumen: alerta de CPA en ventana corta con volumen suficiente para actuar — vale la pena diagnosticar hoy.</p>'
          )
        : `<p>Mock de ${rule.key}: visual QA del arquetipo ${archetype}.</p>`,
    cta_label: ctaLabelFor(isApplicableAction(actionType), platform),
    applicable: isApplicableAction(actionType),

    primary_entity,
    primary_entity_breadcrumb: (() => {
      // Breadcrumb para ubicar la entidad: Campaña (y AdSet cuando aplica).
      // - Campaña: []
      // - AdSet: [Campaña]
      // - Anuncio: [Campaña, AdSet]
      const t = String(primary_entity?.type || '').toUpperCase();
      if (t === 'CAMPAIGN') return [];
      if (t === 'AD') return [campaign.name, scope_entity.name].filter(Boolean);
      return [campaign.name].filter(Boolean);
    })(),
    scope_entity,
    campaign,

    archetype,
    // §6.6: display_mode is always present on the wire. Default to "comparison"; a few
    // pause/concentration tiles set "value_only" explicitly above (meta_28, meta_32).
    criteria: criteria.map((c) => ({ display_mode: 'comparison', ...c })),
    metrics_extended,
    account_benchmarks: rule.key.includes('avg') ? { avg_inline_link_click_ctr: 1.3 } : null,
    window_comparison,
    value_change_display,
    sub_items,
    sub_items_summary,
    diagnostic_score,
    structural_change,

    items,

    // §6.13bis: ordered key list for ContextMetricsBar; [] means "hide the bar".
    metric_keys_to_show: (() => {
      const prefix = ['spend', 'conversions', 'cpa'];
      const kpi = primaryKpi ? primaryKpi.toLowerCase() : null;
      const withKpi = kpi && !prefix.includes(kpi) ? [...prefix, kpi] : prefix;
      const fromCriteria = Array.isArray(criteria)
        ? criteria.map((c) => c?.metric_key).filter((k) => k && !withKpi.includes(k))
        : [];
      return [...withKpi, ...fromCriteria].slice(0, 8);
    })(),

    expected_effects: { applies_to_kpis: [primaryKpi] },
    value_before: value_change_display ? value_change_display.value_before : (bcValueChange ? bcValueChange.before : null),
    value_after: value_change_display ? value_change_display.value_after : (bcValueChange ? bcValueChange.after : null),
    value_unit: value_change_display
      ? (value_change_display.currency || 'ratio')
      : (bcValueChange ? bcValueChange.unit : 'none'),
    impact_score: null,
    confidence: null,
    daily_series: null,

    ...(String(ruleKey || '').toLowerCase() === 'meta_n1_pause_adset_cpa_critical_streak'
      ? {
          daily_series: {
            metric_key: 'cpa',
            metric_label: 'CPA diario',
            window_days: 7,
            format_hint: 'currency',
            target_value: 650,
            bad_when: 'above_target',
            currency: 'UYU',
            series: [
              { date: '2026-05-01', value: 720, spend: 820, conversions: 1 },
              { date: '2026-05-02', value: 910, spend: 910, conversions: 1 },
              { date: '2026-05-03', value: 1120, spend: 1120, conversions: 1 },
              { date: '2026-05-04', value: null, spend: 680, conversions: 0 },
              { date: '2026-05-05', value: 980, spend: 980, conversions: 1 },
              { date: '2026-05-06', value: 1650, spend: 1650, conversions: 1 },
              { date: '2026-05-07', value: null, spend: 1040, conversions: 0 },
            ],
          },
        }
      : {}),
    ...(String(ruleKey || '').toLowerCase() === 'meta_n2_pause_campaign_critical_roas'
      ? {
          daily_series: {
            metric_key: 'roas',
            metric_label: 'ROAS diario',
            window_days: 7,
            format_hint: 'ratio',
            target_value: 3.0,
            bad_when: 'below_target',
            currency: null,
            series: [
              { date: '2026-05-01', value: 2.8, spend: 1100, conversions: 2 },
              { date: '2026-05-02', value: 2.2, spend: 1200, conversions: 1 },
              { date: '2026-05-03', value: 1.9, spend: 1350, conversions: 1 },
              { date: '2026-05-04', value: null, spend: 980, conversions: 0 },
              { date: '2026-05-05', value: 2.6, spend: 1050, conversions: 1 },
              { date: '2026-05-06', value: 1.1, spend: 1450, conversions: 2 },
              { date: '2026-05-07', value: 2.4, spend: 670, conversions: 1 },
            ],
          },
        }
      : {}),

    evidence: {
      analysis_window: { start: '2026-04-30', end: '2026-05-07', days: 7, label: 'Últimos 7 días' },
      ui_metrics: uiMetricsCompat,
      metrics: {
        spend: items?.[0]?.metrics?.spend ?? null,
        roas: items?.[0]?.metrics?.roas ?? null,
        conversions: items?.[0]?.metrics?.conversions ?? null,
        cpa: items?.[0]?.metrics?.cpa ?? null,
      },
      ...(String(ruleKey || '').toLowerCase() === 'meta_33_iterate_winner_roas_and_ctr_above_account_avg'
        ? {
            account: { avg_inline_link_click_ctr: 1.3 },
          }
        : {}),
      ...(String(ruleKey || '').toLowerCase() === 'meta_33_iterate_winner_cpa_and_ctr_above_account_avg'
        ? {
            account: { avg_inline_link_click_ctr: 1.3 },
          }
        : {}),
      ...(String(ruleKey || '').toLowerCase() === 'meta_32_pause_ad_spend_stealing_under_roas_with_other_winners'
        ? {
            peer_ads: [
              { ad_name: 'Anuncio ganador A', spend: 1800, roas: 5.2, conversions: 6, cpa: 300 },
              { ad_name: 'Anuncio ganador B', spend: 1600, roas: 3.8, conversions: 4, cpa: 420 },
              { ad_name: 'Este anuncio', spend: 4200, roas: 1.8, conversions: 3, cpa: 1400 },
            ],
          }
        : {}),
      ...(String(ruleKey || '').toLowerCase() === 'meta_32_pause_ad_spend_stealing_over_cpa_with_other_winners'
        ? {
            peer_ads: [
              { ad_name: 'Anuncio ganador A', spend: 1800, roas: 4.6, conversions: 6, cpa: 300 },
              { ad_name: 'Anuncio ganador B', spend: 1600, roas: 3.2, conversions: 4, cpa: 420 },
              { ad_name: 'Este anuncio', spend: 4200, roas: 2.4, conversions: 3, cpa: 1400 },
            ],
          }
        : {}),
      ...(String(ruleKey || '').toLowerCase() === 'meta_36_consolidate_adsets_high_auction_overlap'
        ? {
            auction_overlap_pairs: [
              {
                adset_a_name: 'AdSet Prospecting - Intereses',
                adset_b_name: 'AdSet Prospecting - Lookalike 1%',
                overlap_pct: 0.46,
                spend_a: 2100,
                spend_b: 1850,
                roas_a: 4.1,
                roas_b: 5.0,
                conversions_a: 4,
                conversions_b: 5,
              },
              {
                adset_a_name: 'AdSet Prospecting - Intereses',
                adset_b_name: 'AdSet Prospecting - Broad',
                overlap_pct: 0.38,
                spend_a: 2100,
                spend_b: 1650,
                roas_a: 4.1,
                roas_b: 4.6,
                conversions_a: 4,
                conversions_b: 3,
              },
              {
                adset_a_name: 'AdSet Prospecting - Lookalike 1%',
                adset_b_name: 'AdSet Prospecting - Broad',
                overlap_pct: 0.42,
                spend_a: 1850,
                spend_b: 1650,
                roas_a: 5.0,
                roas_b: 4.6,
                conversions_a: 5,
                conversions_b: 3,
              },
            ],
          }
        : {}),
      ...(String(ruleKey || '').toLowerCase() === 'meta_37_expand_audience_broad_small_audience_cpa_worsening'
        ? {
            audience_segments: [
              { segment_label: 'Actual (Intereses + Lookalike)', audience_size: 180000, spend_7d: 4200, conversions_7d: 4, cpa_7d: 980, note: 'Audiencia acotada, fatiga más rápida' },
              { segment_label: 'Broad sugerido', audience_size: 2500000, spend_7d: null, conversions_7d: null, cpa_7d: null, note: 'Más alcance y señales para optimizar' },
            ],
            delivery_signals: {
              reach_7d: 62000,
              unique_clicks_7d: 1400,
              frequency_7d: 3.9,
            },
          }
        : {}),
      ...(String(ruleKey || '').toLowerCase() === 'meta_n8_decrease_budget_adset_cpa_rise_soft'
        ? {
            cpa_windows: {
              target_cpa: 650,
              unit: 'currency',
              windows: [
                { label: 'Últimos 7 días', start: '2026-05-01', end: '2026-05-07', cpa: 720 },
                { label: 'Últimos 30 días', start: '2026-04-08', end: '2026-05-07', cpa: 590 },
              ],
            },
          }
        : {}),
      ...(String(ruleKey || '').toLowerCase() === 'meta_n9_decrease_budget_campaign_roas_decline_soft'
        ? {
            roas_windows: {
              target_roas: 5.0,
              unit: 'ratio',
              windows: [
                { label: 'Últimos 7 días', start: '2026-05-01', end: '2026-05-07', roas: 4.1 },
                { label: 'Últimos 30 días', start: '2026-04-08', end: '2026-05-07', roas: 5.6 },
              ],
            },
          }
        : {}),
      ...(String(ruleKey || '').toLowerCase() === 'meta_n10_decrease_budget_campaign_cpa_rise_soft'
        ? {
            cpa_windows: {
              target_cpa: 650,
              unit: 'currency',
              windows: [
                { label: 'Últimos 7 días', start: '2026-05-01', end: '2026-05-07', cpa: 840 },
                { label: 'Últimos 30 días', start: '2026-04-08', end: '2026-05-07', cpa: 710 },
              ],
            },
          }
        : {}),
      ...(String(ruleKey || '').toLowerCase() === 'meta_n11_pause_ad_ctr_decline'
        ? {
            ctr_windows: {
              threshold_ratio: 0.4,
              unit: 'ratio',
              windows: [
                { label: 'Últimos 7 días', start: '2026-05-01', end: '2026-05-07', ctr: 0.007 },
                { label: '7 días previos', start: '2026-04-24', end: '2026-04-30', ctr: 0.02 },
              ],
            },
          }
        : {}),
      ...(String(ruleKey || '').toLowerCase() === 'meta_n12_alert_adset_cpa_spike_48h'
        ? {
            analysis_window: { start: '2026-05-05', end: '2026-05-06', days: 2, label: 'Últimas 48 horas (alerta)' },
          }
        : {}),
    },
    ui_metrics: null,
    action_params: {},
  };
};

const RULES = (() => {
  // A partir del catálogo compartido (resumen). Mantener ~82 reglas para QA visual.
  const meta = [
    'meta_24_increase_budget_adset_good_roas_high_utilization',
    'meta_24b_increase_budget_campaign_good_roas_high_utilization',
    'meta_24c_increase_budget_adset_good_cpa_high_utilization',
    'meta_24d_increase_budget_campaign_good_cpa_high_utilization',
    'meta_25_decrease_budget_adset_high_cpa_overburn',
    'meta_25b_decrease_budget_campaign_high_cpa_overburn',
    'meta_26_increase_budget_adset_good_roas_high_utilization',
    'meta_26b_increase_budget_campaign_good_roas_high_utilization',
    'meta_27_decrease_budget_adset_high_cpa_overburn',
    'meta_27b_decrease_budget_campaign_high_cpa_overburn',
    'meta_28_pause_ad_when_spend_high_and_no_conversions',
    'meta_29_increase_bid_costcap_low_delivery_good_roas_30d',
    'meta_30_replace_asset_low_3sec_view_rate',
    'meta_31_replace_asset_low_3sec_view_rate_nonvideo',
    'meta_32_pause_ad_spend_stealing_under_roas_with_other_winners',
    'meta_32_pause_ad_spend_stealing_over_cpa_with_other_winners',
    'meta_33_iterate_winner_roas_and_ctr_above_account_avg',
    'meta_33_iterate_winner_cpa_and_ctr_above_account_avg',
    'meta_34_mitigate_audience_fatigue_high_frequency_ctr_drop',
    'meta_35_switch_to_advantage_plus_manual_under_roas_low_conversions',
    'meta_35_switch_to_advantage_plus_manual_over_cpa_low_conversions',
    'meta_36_consolidate_adsets_high_auction_overlap',
    'meta_37_expand_audience_broad_small_audience_cpa_worsening',
    'meta_38_optimize_lp_speed_high_dropoff',
    'meta_39_improve_lp_relevance_high_ctr_low_roas',
    'meta_39_improve_lp_relevance_high_ctr_high_cpa',
    'meta_40_enable_advantage_plus_placements_when_manual_cpa_worse_than_historical',
    'meta_41_create_reels_specific_creative_high_reels_spend_low_ctr',
  ];

  const metaNExplicit = [
    'meta_N1_pause_adset_cpa_critical_streak',
    'meta_N2_pause_campaign_critical_roas',
    'meta_N3_increase_budget_campaign_roas_high_aggressive',
    'meta_N4_increase_budget_campaign_cpa_low_aggressive',
    'meta_N5_increase_budget_adset_roas_high_aggressive',
    'meta_N6_increase_budget_adset_cpa_low_aggressive',
    'meta_N7_decrease_budget_adset_roas_decline_soft',
    'meta_N8_decrease_budget_adset_cpa_rise_soft',
    'meta_N9_decrease_budget_campaign_roas_decline_soft',
    'meta_N10_decrease_budget_campaign_cpa_rise_soft',
    'meta_N11_pause_ad_ctr_decline',
    'meta_N12_alert_adset_cpa_spike_48h',
    'meta_N13_alert_adset_roas_drop_48h',
    'meta_N14_alert_campaign_cpa_spike_48h',
    'meta_N15_alert_campaign_roas_drop_48h',
    'meta_N16_alert_adset_impressions_collapse_24h',
    'meta_N17_alert_adset_cpm_spike',
    'meta_N18_alert_ad_conversion_rate_decline',
    'meta_N19_mitigate_adset_frequency_saturation',
    'meta_N20_pause_ad_kill_switch_early',
    'meta_N21_pause_adset_post_learning_high_cpa',
    'meta_N22_pause_adset_post_learning_low_roas',
    'meta_N23_diversify_campaign_spend_concentration',
    'meta_N24_iterate_winner_ad_high_roas_low_spend',
    'meta_N25_iterate_winner_ad_low_cpa_low_spend',
    'meta_N26_refresh_creatives_account_ctr_decline',
    'meta_N27_pause_adset_zombie_low_impressions',
    'meta_N28_raise_cost_cap_low_utilization',
  ];

  const google = [
    'increase_budget_when_capped_and_good_roas',
    'increase_budget_when_capped_and_good_cpa',
    'reduce_target_roas_when_uncapped_and_good_roas',
    'reduce_target_cpa_when_uncapped_and_good_cpa',
    'increase_target_roas_when_capped_and_good',
    'reduce_target_cpa_when_capped_and_good',
    'increase_target_cpa_when_uncapped_and_good',
    'add_keywords_from_good_search_terms_roas',
    'add_keywords_from_good_search_terms_cpa',
    'add_negative_keywords_from_bad_search_terms_roas',
    'add_negative_keywords_from_bad_search_terms_cpa',
    'pause_keywords_under_target_spending_day_budget_roas',
    'pause_keywords_under_target_spending_day_budget_cpa',
    'exclude_bad_placements_spending_day_budget_roas',
    'exclude_bad_placements_spending_day_budget_cpa',
    'create_campaign_for_good_placements_spending_day_budget_roas',
    'create_campaign_for_good_placements_spending_day_budget_cpa',
    'replace_low_asset_when_campaign_roas_low',
    'pause_video_ad_when_view_rate_high_roas_low',
    'exclude_offer_when_spend_high_no_conversions',
    'split_top_sellers_when_roas_very_high',
    'suggest_exact_match_from_high_roas_broad',
    'add_keywords_from_shopping_to_search_campaign',
  ];

  const diag = [
    'diag_scale_budget',
    'diag_rotate_creative',
    'diag_reduce_budget_saturation',
    'diag_increase_budget_underfunded',
  ];

  // Dejar 82 aprox: diag(4) + meta(~29) + meta_N(28) + google(23) = 84
  // meta_N base array se reemplaza por explicit para que queden keys reales.
  const keys = [...diag, ...meta, ...metaNExplicit, ...google];

  return keys.map((key, idx) => {
    const isGoogle = key.startsWith('increase_') || key.startsWith('reduce_') || key.startsWith('add_') || key.startsWith('pause_') || key.startsWith('exclude_') || key.startsWith('create_') || key.startsWith('replace_') || key.startsWith('split_') || key.startsWith('suggest_');
    const platform = isGoogle ? 'GOOGLE' : 'META';

    const primaryKpi = (() => {
      if (key.includes('_cpa')) return 'CPA';
      if (key.includes('_ctr')) return 'CTR';
      if (key.includes('_conversions')) return 'CONVERSIONS';
      if (key.includes('_spend')) return 'SPEND';
      return 'ROAS';
    })();

    const action_type = defaultActionType(key);

    // Heurística entity_type:
    const entity_type = (() => {
      if (key.includes('keyword')) return 'KEYWORD';
      if (key.includes('search_term')) return 'SEARCH_TERM';
      if (key.includes('placement')) return 'PLACEMENT';
      if (key.includes('offer') || key.includes('product')) return 'OFFER';
      if (key.includes('asset')) return 'ASSET';
      if (key.includes('campaign')) return 'CAMPAIGN';
      if (key.includes('adset') || key.includes('ad_group')) return 'AD_GROUP';
      if (key === 'meta_29_increase_bid_costcap_low_delivery_good_roas_30d') return 'AD_GROUP';
      return 'AD';
    })();

    const evaluation_windows =
      key.includes('_48h') || key.includes('spike') ? [2, 14] :
      key.includes('_7d') && key.includes('_30d') ? [7, 30] :
      null;

    const intent = defaultIntent(key);

    const description = (() => {
      // Descripciones breves y explicativas (para chips de motivo en UI)
      if (key === 'meta_24_increase_budget_adset_good_roas_high_utilization') {
        return 'Encontramos AdSets que superan tus objetivos y están consumiendo todo su presupuesto 💪🏻';
      }
      if (key === 'meta_34_mitigate_audience_fatigue_high_frequency_ctr_drop') {
        return 'Detectamos fatiga: la frecuencia subió y el CTR cayó en las últimas 48 horas.';
      }
      if (key === 'meta_35_switch_to_advantage_plus_manual_under_roas_low_conversions') {
        return 'Esta campaña está en puja manual con ROAS bajo y pocas conversiones. Advantage+ puede mejorar el delivery.';
      }
      if (key === 'meta_35_switch_to_advantage_plus_manual_over_cpa_low_conversions') {
        return 'Esta campaña está en puja manual con CPA alto y pocas conversiones. Advantage+ puede mejorar el delivery.';
      }
      if (key === 'meta_36_consolidate_adsets_high_auction_overlap') {
        return 'Detectamos AdSets que compiten entre sí (overlap alto). Consolidarlos reduce competencia interna.';
      }
      if (key === 'meta_37_expand_audience_broad_small_audience_cpa_worsening') {
        return 'Tu audiencia es pequeña y el CPA viene empeorando. Ampliar a Broad puede destrabar el delivery.';
      }
      if (key === 'meta_40_enable_advantage_plus_placements_when_manual_cpa_worse_than_historical') {
        return 'Con placements manuales, estás restringiendo inventario y tu CPA quedó peor que el histórico. Activar Advantage+ puede destrabar delivery.';
      }
      if (key === 'meta_41_create_reels_specific_creative_high_reels_spend_low_ctr') {
        return 'Reels está consumiendo gran parte del gasto, pero su CTR es bajo. Recomendamos un creativo específico para Reels.';
      }
      if (key === 'meta_N1_pause_adset_cpa_critical_streak') {
        return 'Detectamos una racha crítica de CPA alto en este AdSet. Recomendamos pausarlo para cortar pérdidas.';
      }
      if (key === 'meta_N2_pause_campaign_critical_roas') {
        return 'Detectamos una racha crítica de ROAS bajo en esta campaña. Recomendamos pausarla para cortar pérdidas.';
      }
      if (key === 'meta_N8_decrease_budget_adset_cpa_rise_soft') {
        return 'El CPA viene subiendo en este AdSet. Recomendamos bajar un poco el presupuesto para reducir pérdida mientras se recupera.';
      }
      if (key === 'meta_N9_decrease_budget_campaign_roas_decline_soft') {
        return 'El ROAS viene bajando en esta campaña. Recomendamos bajar un poco el presupuesto para reducir pérdida mientras se estabiliza.';
      }
      if (key === 'meta_N10_decrease_budget_campaign_cpa_rise_soft') {
        return 'El CPA viene subiendo en esta campaña. Recomendamos bajar un poco el presupuesto para reducir pérdida mientras se recupera.';
      }
      if (key === 'meta_N11_pause_ad_ctr_decline') {
        return 'El CTR de los últimos 7 días cayó por debajo del 40% del CTR de los 7 días previos. Posible fatiga creativa detectada. Revisá el anuncio.';
      }
      if (key === 'meta_N12_alert_adset_cpa_spike_48h') {
        return 'El CPA del Ad Set en 48h superó en al menos un 50% al promedio de 14 días, con conversiones suficientes para confiar en la señal.';
      }
      if (key === 'meta_29_increase_bid_costcap_low_delivery_good_roas_30d') {
        return 'Este AdSet tiene un ROAS por encima de tu objetivo pero está limitado por su Target CPA.';
      }
      if (key === 'meta_30_replace_asset_low_3sec_view_rate') {
        return 'Encontramos anuncios de video donde la mayoría de los usuarios no ve más de 3 segundos.';
      }
      if (key === 'meta_31_replace_asset_low_3sec_view_rate_nonvideo') {
        return 'Encontramos anuncios de video donde la mayoría de los usuarios no ve más de 3 segundos.';
      }
      if (key === 'meta_33_iterate_winner_roas_and_ctr_above_account_avg') {
        return 'Estos anuncios cumplen tus objetivos e incluso tienen mejor CTR que el resto de la cuenta.';
      }
      if (key === 'meta_33_iterate_winner_cpa_and_ctr_above_account_avg') {
        return 'Estos anuncios cumplen tus objetivos e incluso tienen mejor CTR que el resto de la cuenta.';
      }
      return `Mock generado para ${key}.`;
    })();

    return {
      id: 100 + idx,
      key,
      name: toRuleNameFromKey(key),
      description,
      ui_metadata: {
        category: platform === 'GOOGLE' ? 'keywords' : 'budget',
        rule_number: String(idx + 1),
      },
      platform,
      primary_kpi: primaryKpi,
      intent,
      action_type,
      entity_type,
      evaluation_mode: evaluation_windows ? 'ALL_WINDOWS_OR_TREND_DECLINING' : null,
      evaluation_windows,
    };
  });
})();

export function buildOptimizationsV2AllRulesMock() {
  const groups = RULES.map((rule, idx) => ({
    primary_kpi: rule.primary_kpi,
    rule: {
      id: rule.id,
      key: rule.key,
      name: rule.name,
      description: rule.description,
      ui_metadata: rule.ui_metadata,
    },
    suggestions: [makeSuggestion(rule, idx + 1)],
  }));

  // --- QA variant 1: FAILED status — retry CTA must appear (archetype D) ---
  const qaRuleFailed = RULES.find((r) => String(r.action_type || '').toUpperCase().startsWith('INCREASE_BUDGET')) || RULES[0];
  const qaFailedBase = makeSuggestion(qaRuleFailed, 9001);
  const qaFailedSuggestion = {
    ...qaFailedBase,
    id: 9001,
    status: 'FAILED',
    rule: {
      ...qaFailedBase.rule,
      key: `${qaFailedBase.rule?.key || 'qa_rule'}_qa_failed`,
      name: '[QA] Falló — debería mostrar botón Reintentar',
    },
  };
  groups.push({
    primary_kpi: qaRuleFailed.primary_kpi,
    rule: {
      id: 9001,
      key: `${qaRuleFailed.key}_qa_failed`,
      name: '[QA] Falló — debería mostrar botón Reintentar',
      description: 'Variante QA: status FAILED para probar el CTA de reintento.',
      ui_metadata: { category: 'qa', rule_number: 'QA-1' },
    },
    suggestions: [qaFailedSuggestion],
  });

  // --- QA variant 2: item with is_liked === false must be filtered out (archetype E) ---
  const qaRuleE = RULES.find((r) => String(r.action_type || '').toUpperCase().startsWith('PAUSE_')) || RULES[1];
  const qaIsLikedBase = makeSuggestion(qaRuleE, 9002);
  const qaIsLikedItems = Array.isArray(qaIsLikedBase.items) ? qaIsLikedBase.items : [];
  const qaIsLikedSuggestion = {
    ...qaIsLikedBase,
    id: 9002,
    rule: {
      ...qaIsLikedBase.rule,
      key: `${qaIsLikedBase.rule?.key || 'qa_rule'}_qa_is_liked`,
      name: '[QA] is_liked=false — ese item no debe aparecer',
    },
    items: [
      ...qaIsLikedItems,
      {
        id: 99990,
        item_type: 'AD_GROUP',
        item_text: 'Item descartado (is_liked=false)',
        target_entity: {
          id: 99990,
          external_id: '99990',
          name: 'Adset descartado',
          platform: qaRuleE.platform || 'META',
          type: 'AD_GROUP',
          thumbnail_url: null,
          permalink_url: null,
        },
        metrics: { spend: 100, roas: 0.2, conversions: 0, cpa: null },
        metrics_extended: { spend: 100, roas: 0.2, conversions: 0, cpa: null, currency: 'USD' },
        criteria_evaluation: [],
        value_change: null,
        action: null,
        created_at: nowIso(),
        applied_at: null,
        is_liked: false,
      },
    ],
  };
  groups.push({
    primary_kpi: qaRuleE.primary_kpi,
    rule: {
      id: 9002,
      key: `${qaRuleE.key}_qa_is_liked`,
      name: '[QA] is_liked=false — ese item no debe aparecer',
      description: 'Variante QA: uno de los items tiene is_liked=false y no debe renderizarse.',
      ui_metadata: { category: 'qa', rule_number: 'QA-2' },
    },
    suggestions: [qaIsLikedSuggestion],
  });

  // --- QA variant 3: Múltiples monedas sentinel — total_cost=null, currency='Múltiples monedas' (archetype F) ---
  const qaRuleF = RULES.find((r) => ['SEARCH_TERM', 'KEYWORD', 'PLACEMENT', 'OFFER', 'ASSET'].includes(String(r.entity_type || '').toUpperCase())) || RULES[2];
  const qaMultiCurrBase = makeSuggestion(qaRuleF, 9003);
  const qaMultiCurrSuggestion = {
    ...qaMultiCurrBase,
    id: 9003,
    rule: {
      ...qaMultiCurrBase.rule,
      key: `${qaMultiCurrBase.rule?.key || 'qa_rule'}_qa_multi_currency`,
      name: '[QA] Múltiples monedas — totales no aplicables',
    },
    sub_items_summary: {
      total_count: 6,
      selected_count: 4,
      total_cost: null,
      total_conversions: 3,
      currency: 'Múltiples monedas',
    },
  };
  groups.push({
    primary_kpi: qaRuleF.primary_kpi,
    rule: {
      id: 9003,
      key: `${qaRuleF.key}_qa_multi_currency`,
      name: '[QA] Múltiples monedas — totales no aplicables',
      description: 'Variante QA: sub_items_summary.currency="Múltiples monedas" debe mostrar chip de advertencia.',
      ui_metadata: { category: 'qa', rule_number: 'QA-3' },
    },
    suggestions: [qaMultiCurrSuggestion],
  });

  // Orden estable por id
  groups.sort((a, b) => (a?.rule?.id || 0) - (b?.rule?.id || 0));

  return {
    active: { groups },
    expired: { groups: [] },
  };
}

